import { IAnnotation } from "app/interfaces/annotation-and-rags";
import { Asset } from "./asset";
import { Building } from "./building";

export class BuildingReview {
	id: number;
	state: BuildingReviewStateType;
	title = 'New Review'
	review: { dates: { start: Date, end: Date }, rag: 'green' | 'amber' | 'red', document: { key: string } };
	createdBy: { id?: number, name: string, email?: string };
	building: Building;
	collection: { id: number, assets: Asset[] };
	battery: IAnnotation;
	isNew: boolean;

	/**
	 * 
	 * @param data	An existing review already saved
	 * @returns 
	 */
	constructor(data?: any) {
		if (!data) {
			return;
		}

		const state = data.state ?? data.review?.state;
		const start = data.start ?? data.review?.reviewDate;
		const end = data.end ?? data.review?.reviewDateEnd;
		const rag = data.rag ?? data.review?.rag;
		const document: { key: string } = { key: data.documentKey ?? data.review?.document?.key ?? null };

		this.isNew = data.isNew ?? false;

		if (!state) {
			// Use the createNewReview for new reviews
			return;
		}
		this.id = data.id;
		this.state = state;
		this.building = new Building(data.building);
		if (data.collection) {
			this.collection = data.collection;
		} else {
			this.collection = { id: data.config.cid, assets: data.assets.map(a => new Asset(a)) };
		}
		this.review = { dates: { start: new Date(start), end: new Date(end) }, rag, document };
		this.createdBy = data.user ?? null;
		this.title = `${this.review.dates.start.toLocaleDateString()} to ${this.review.dates.end.toLocaleDateString()}`;

		if (data.battery) {
			this.battery = { rag: data.battery.rag, text: data.battery.annotation };
		}
	}

	createNewReview(building: Building, start: Date, end: Date, collection: { id: number, assets: Asset[] }) {
		this.building = building;
		this.collection = collection;
		this.review.dates = { start, end }
		this.createdBy = { id: null, name: null };
	}

	serialise() {
		return {
			title: this.title,
			review: this.review,
			building: this.building?.id,
			collectionId: this.collection?.id
		};
	}
}

export type BuildingReviewStateType = 'new' | 'init' | 'active' | 'done';
